import { Order } from '../../types/orders';
import { OperationLineItem } from '../types';

export enum ActionTypes {
    Open = '[orders/cancel] OPEN',
    Dismiss = '[orders/cancel] DISMISS',
    InvokeRequest = '[orders/cancel] START',
    SuccessResponse = '[orders/cancel] SUCCESS',
    ErrorResponse = '[orders/cancel] ERROR',
}

export interface Open {
    type: ActionTypes.Open;
    payload: {
        order: Order;
    };
}

export function openCancel(order: Order): Open {
    return {
        type: ActionTypes.Open,
        payload: {
            order,
        },
    };
}

export interface Dismiss {
    type: ActionTypes.Dismiss;
    payload: {};
}

export function dismissModal(): Dismiss {
    return {
        type: ActionTypes.Dismiss,
        payload: {},
    };
}

export interface Cancel {
    type: ActionTypes.InvokeRequest;
    payload: {
        accountId: string;
        order: Order;
        items: OperationLineItem[];
        authorizationId: string | undefined;
    };
}

export function cancelItems(accountId: string, order: Order, items: OperationLineItem[], authorizationId: string | undefined): Cancel {
    return {
        type: ActionTypes.InvokeRequest,
        payload: {
            accountId,
            order,
            items,
            authorizationId,
        },
    };
}

export interface CancelSuccess {
    type: ActionTypes.SuccessResponse;
    meta: {
        cause: Cancel;
    };
}

export interface CancelError {
    type: ActionTypes.ErrorResponse;
    payload: {
        code: string;
        message: string;
        errors: any;
    };
    meta: {
        cause: Cancel;
    };
}

export type OperationResult = CancelSuccess | CancelError;

export type Actions = Open | Dismiss | Cancel | CancelSuccess | CancelError;
